import styled from "styled-components";

import VerticalCenter from "common/fragments/VerticalCenter";


export const StyledThumbnailOverlay = styled(VerticalCenter)`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	transition: 0.1s;
	opacity: 0;
	color: #fff;
	cursor: pointer;
	&:hover {
		background-color: rgba(0,0,0,0.4);
		opacity: 1;
	}
`;

export const StyledNewBanner = styled.span`
	top: 9px;
    right: -58px;
    left: auto;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    opacity: 1;
    z-index: 2;
	background: #ffc928;
	width: 163px;
    position: absolute;
    text-align: center;
    line-height: 34px;
    letter-spacing: 1px;
    color: #564103;
    font-weight: 800;
    font-size: 14px;
    text-shadow: 1px 1px 0px rgba(255,255,255,0.8);
`;



// WEBPACK FOOTER //
// ./src/panels/catalog/fragments/course/styled.tsx